<template>
  <div class="mv-wrapper">
    <div class="mv-top">
      <b-button class="mv-top-btn" @click="$bvModal.show(`add-category`)" variant="link">
        <b-icon-plus />Add Categories
      </b-button>
    </div>

    <div class="categories-wrapper">
      <template v-for="(category) in categories">
        <CategoryCard
          :key="category.id"
          :index="category.id"
          :category="category"
          v-if="category['is_active']===true"
        />
      </template>
    </div>
    <!-- <template v-if="menu && menuId">
      <div class="menu-title">{{menu.menu_name}}</div>
      <div
        class="no-data"
        v-if="menu.categories.length===0"
      >There are no categories in this menu yet. Click above to add category</div>
      <div v-else class="categories">
        <draggable
          v-model="menu.categories"
          :disabled="!enabled"
          class="list-group"
          ghost-class="ghost"
          @start="dragging = true"
          @change="checkEnd"
          handle=".handle"
        >
          <template v-for="(category,index) in menu.categories">
            <template v-if="category.is_active">
              <CategoryCard
                :key="index"
                :index="index"
                :categories="menu.categories"
                :menuId="menuId"
                :category="category"
              />
            </template>
          </template>
        </draggable>
      </div>
    </template>-->
    <validation-observer v-slot="{invalid}">
      <b-modal
        :ok-disabled="invalid"
        @ok="addCategory"
        id="add-category"
        size="md"
        title="Add Category"
      >
        <TextInput :rules="`required`" placeholder="Enter Category" v-model="form.category" />
        <TextInput placeholder="Enter Description" v-model="form.description" />
        <!-- <MultipleSelect
          name="select-item"
          v-model="selectedItems"
          placeholder="Type to Search Items"
          :options="items"
          :isLoading="isLoading"
          :onsearch="getItems"
          :selectedItems="selectedItems"
          :rules="'required'"
          trackBy="name"
        >
          <template v-slot:options="slotProps">
            <ItemCard
              :key="slotProps.options.option.name"
              :item="slotProps.options.option"
              :editable="false"
            />
          </template>
          <template v-slot:beforeList>
            <template v-for="(item,index) in selectedItems">
              <div :key="'selected'+index" class="selected-options">
                <div class="cancel-wrapper">
                  <b-icon @click="removeItem(index)" icon="X" class="cancel-selected"></b-icon>
                </div>

                <ItemCard :menuId="menuId" :item="item" :editable="false" />
              </div>
            </template>
          </template>
        </MultipleSelect>-->
      </b-modal>
    </validation-observer>
  </div>
</template>

<script>
import CategoryCard from "../pages/components/CategoryCard";
import { auth } from "../Firebase/firebase";
//import draggable from "vuedraggable";
import { baseurl } from "../helpers/helper";
//import Botton from "../pages/components/Botton";
import TextInput from "./components/Inputs/TextInput";
import { ValidationObserver } from "vee-validate";
//import MultipleSelect from "./components/Inputs/MultipleSelect";
//import ItemCard from "./components/ItemCard";
export default {
  components: {
    CategoryCard,
    //draggable,
    //Botton,
    TextInput,
    ValidationObserver
    //MultipleSelect,
    //ItemCard
  },
  data() {
    return {
      selectedItems: [],
      countries: [],
      fetchingItems: false,
      isLoading: false,
      menuId: "",
      currentMenu: "",
      form: {
        category: "",
        description: ""
      },
      enabled: true,
      dragging: false,
      baseurl: "",
      fetchingCategories:false,
    };
  },
  methods: {
    async addCategory() {
      const response = await this.$store.dispatch(
        "Category/createCategory",
        this.form
      );
      return response;
    },

    async getItems(query) {
      this.isLoading = true;
      const response = await this.$store.dispatch("Item/fetchItems", {
        userId: auth.currentUser.uid,
        limit: 20,
        query
      });
      this.isLoading = false;
      return response;
    },
    removeItem(index) {
      this.selectedItems.splice(index, 1);
    },
    async fetchCategories(){
      this.fetchingCategories=true
      const response= await this.$store.dispatch("Category/fetchCategories",{
        limit:20,
        query:""
      })
      this.fetchingCategories=false
      return response
    }
  },
  computed: {
    categories() {
      return this.$store.state.Category.categories;
    },
    userProfile() {
      return this.$store.state.Auth.userProfile;
    },
    items() {
      return this.$store.state.Item.items;
    }
  },
  mounted() {
    this.fetchCategories()
    /* this.menuId = this.$route.params.menuId;
    this.baseurl = baseurl;
    this.fetchMenu(); */
    //this.getItems("")
  }
};
</script>

<style scoped>
.mv-wrapper {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 20px;
}

.mv-wrapper .mv-top {
  display: flex;
  justify-content: flex-end;
}

.mv-wrapper .mv-top .mv-top-btn {
  color: #2ca8ff;
  margin: 0;
  padding: 0 10px;
}

.mv-wrapper .mv-top .mv-top-btn:hover {
  color: #2ca8ff;
}

.mv-wrapper .menu-title {
  font-size: 18px;
  font-weight: 600;
}

.mv-wrapper .categories {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 30px;
}


</style>